export default __webpack_public_path__ + "static/4-ea8bec01f9589d97507b3dd0b7db66f7.jpeg";